import script from "./CasesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CasesPage.vue?vue&type=script&setup=true&lang=js"

import "./CasesPage.vue?vue&type=style&index=0&id=5ee549fb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ee549fb"]])

export default __exports__